(function () {
    'use strict';

    angular
            .module('app')
            .component('updatePaymentDetails', {
                controller: UpdatePaymentDetailsController,
                bindings: {
                    resolve: '<',
                    close: '&',
                    dismiss: '&'
                },

                templateUrl: 'app/components/update-payment-details/update-payment-details.component.html'
            });

    UpdatePaymentDetailsController.$inject = ['$http', '$httpParamSerializer', '$rootScope', 'ssNotificationService', 'host', 'usSpinnerService', 'customEcommerceAnalytics'];

    function UpdatePaymentDetailsController($http, $httpParamSerializer, $rootScope, ssNotificationService, host, usSpinnerService, customEcommerceAnalytics) {
        var me = this;

        me.$onInit = onInit;
        me.update = update;
        me.cancel = cancel;

        function onInit() {}
        function update(plan, useSavedCard, card) {
            me.disabledSubmitButton = true;
            usSpinnerService.spin('spinner-1');

            var planData = me.resolve.planInfo;

            //TODO: Move into a service
            var url = host + 'subscription/updatePayment/' + plan + '?';

            var queryParams = {
                use_saved_card: useSavedCard
            };

            if (!useSavedCard) {
                queryParams.cardHolderName = card.cardHolderName;
                queryParams.number = card.cardNumber;
                queryParams.cvc = card.cvv;
                queryParams.exp_month = card.expirationMonth;
                queryParams.exp_year = card.expirationYear;
            }

            var queryString = $httpParamSerializer(queryParams);
            url += queryString;

            $http.put(url)
                    .then(function onUpdateSuccess() {
                        usSpinnerService.stop('spinner-1');

                        var userRandomId = $rootScope.user.id + (Math.random() * 10);
// TODO: CC Please verify ecommerce analytics entry.
                        // Clear transaction
                        customEcommerceAnalytics.clearTrans();

                        // start the transaction
                        customEcommerceAnalytics.addTransaction({
                            id: userRandomId,
                            affiliation: planData.planEnum,
                            revenue: planData.subscriptionCharge,
                            shipping: '0',
                            tax: '0'
                        });

                        customEcommerceAnalytics.addItem({
                            id: userRandomId,
                            name: planData.planEnum,
                            sku: planData.planEnum + '-SUB',
                            category: planData.planEnum,
                            price: planData.subscriptionCharge,
                            quantity: 1
                        });

                        // send transaction
                        customEcommerceAnalytics.trackTrans();


                        me.disabledSubmitButton = false;

                        me.close({$value: {
                                planName: me.resolve.planInfo.label
                            }});
                    })
                    .catch(function onUpdateError(error) {
                        ssNotificationService.add({
                            type: 'danger',
                            msg: error.data
                        });

                        usSpinnerService.stop('spinner-1');
                        $scope.disabledSubmitButton = false;
                    });
        }
        function cancel() {
            me.dismiss();
        }


    }

})();
